// extracted by mini-css-extract-plugin
module.exports = {"published":"Chapters_published__3uj5H","inProgress":"Chapters_inProgress__2OcfX","inReview":"Chapters_inReview__ENUKw","changesRequired":"Chapters_changesRequired__vFj9l"};